<template>
  <div id="container" style="    width: 100%;  "   class="scrollView">
    <a-spin :spinning="reloading">
     <div  :style="scrollView" style="    width: 100%;   padding: 20px 40px;" class="scrollViewPage
     ">
      <div style="display: flex;margin-bottom: 20px;    align-items: center;">
        <a-input-search  class="searchmobile" v-model:value="mobile" placeholder="搜索手机号" enter-button @search="onSearch" 
        />
        <a-button style="margin-left: 20px;background: #00b2b9;border-color: #00b2b9;" @click="addShow()" type="primary"><plus-outlined
            :style="{ fontSize: '16px', color: '#fffff' }" />新增</a-button>
      </div>
      <div  >

        <a-form name="editDataSource" ref="userformRef" :model="modalEdit">
          <a-table rowKey='companyId' :columns="columns" :data-source="modalEdit.editDataSource" bordered
            class="tablestyle" :pagination="false" @change="handleTableChange">
            <template #bodyCell="{ column, text, record, index }">

              <template v-if="((pagination.companyId==793)?['clientName','department','subCompany', 'post', 'mobile']:['clientName', 'post', 'mobile']).includes(column.dataIndex)">
                <div :class="record">
                  <template v-if="editableData &&
      editableData.length > 0 &&
      editableData.find((item) => item.clientId == record.clientId)
      ">
                    <a-form-item class="tableStyle" :prop="column.dataIndex + '.' + index"
                      :rules="rules[column.dataIndex]">
                      <a-select v-if="column.dataIndex === 'subCompany'" v-model:value="
                     modalEdit.editDataSource.find(
      (item) => item.clientId == record.clientId
    )[column.dataIndex] " :options="belongUnitOptions">

                      </a-select>
                      <a-input v-else v-model:value="modalEdit.editDataSource.find(
      (item) => item.clientId == record.clientId
    )[column.dataIndex]" :disabled="column.dataIndex === 'mobile'" style=" margin: -5px 0" />

                    </a-form-item>



                  </template>
                  <template v-else>
                    <span>{{ text }}</span>
                  </template>



                </div>
              </template>
              <template v-else-if="column.dataIndex === 'action'">
                <div class="editable-row-operations">

                  <span v-if="editableData && editableData.length > 0 &&
      editableData.find((item) => item.clientId == record.clientId)
      " style="word-break: keep-all;">
                    <a class="actionStyle" @click="cancel(record.clientId)">取消</a>
                    <a class="actionStyle" @click="toModalVisble(record.clientId, false)">确认</a>
                    <a class="actionStyle" v-if="index == 0" disabled style="color:'gray'">删除</a>
                    <a v-else class="actionStyle" @click="toModalVisble(record.clientId, true)">删除</a>
                  </span>
                  <span v-else style="word-break: keep-all;">
                    <a class="actionStyle" @click="editItem(record.clientId)">编辑</a>
                    <a class="actionStyle" @click="editArticleCategoryItem(record.clientId)"
                      v-if="pagination.companyId == 750 || pagination.companyId == 789 || companyType == 6||pagination.companyId == 32 ">订阅设置</a>
                    <a class="actionStyle" v-if="record.category == false" disabled style="color:'gray'">删除</a>
                    <a v-else class="actionStyle" @click="toModalVisble(record.clientId, true)">删除</a>
                  </span>
                </div>
              </template>

            </template>


          </a-table>
        </a-form>
        <div>
        </div>
      </div>
     </div>
     <div style="display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;">
          <span style="margin-right: 10px;">共{{ pagination.total }} 条</span> <a-pagination
            v-model:current="pagination.current" v-model:page-size="pagination.pageSize"
         

            :page-size-options="pagination.pageSizeOptions" :total="pagination.total" show-size-changer
            @change="handleTableChange" size="medium" />
        </div>
      
    </a-spin>
  </div>

  <a-modal centered width="40%" title="新增用户" v-model:visible="visible" :afterClose="afterClose" :closable="false"
    :confirmLoading="confirmLoading" @ok="toAdd">
    <div>
      <a-form ref="newFormref" :rules="rules" :model="formState" name="basic" :label-col="{ span: 4 }"
        autocomplete="off">
        <a-form-item label="用户名" name="clientName">
          <a-input v-model:value="formState.clientName" />
        </a-form-item>
        <template v-if="pagination.companyId == 793">
          <a-form-item label="所属单位" name="subCompany">
          <a-select v-model:value="formState.subCompany" :options="belongUnitOptions"></a-select>
        </a-form-item>
        <a-form-item label="所在处室" name="department">
          <a-input v-model:value="formState.department" />
        </a-form-item>
        </template>
        <a-form-item label="职位" name="post">
          <a-input v-model:value="formState.post" />
        </a-form-item>
        <a-form-item label="手机号码" name="mobile">
          <a-input v-model:value="formState.mobile" />
        </a-form-item>

      </a-form>
    </div>
  </a-modal>


  <a-modal centered width="20%" title="" v-model:visible="modalVisible" :afterClose="afterCloseModal" :closable="false"
    :footer="null">
    <div style="text-align: center;">
      <p>{{ deleteVisible == true ? '确定删除此用户？' : '确定修改此用户信息？' }}</p>
      <div>
        <a-button @click="toModal(null)" style="margin-right: 30px;" type="primary"
          :loading="confirmLoading">确认</a-button>
        <a-button @click="afterCloseModal">取消</a-button>
      </div>
    </div>
  </a-modal>
  <a-modal centered width="50%" title="分配文章类别" v-model:visible="modalVisibleCategory" :afterClose="afterCloseModal"
    :confirmLoading="confirmLoading" @ok="toSetCategory">
    <div style="margin: 20px 0px 10px 0px;">

      <div style="display: flex;justify-content: center;">
        <span style="word-break: keep-all;    align-items: center;">分配文章类别：</span>
        <a-select class="categorySelect" v-model:value="categoryListValue" :options="categoryList" mode="tags"
          :size="size" placeholder="请选择文章类别" style="width: 100%"></a-select>

      </div>
    </div>
  </a-modal>
  <KeywordComponent :showModalKeywordVisible="showModalKeywordVisible" @toShowKeyword="toShowKeyword" :clientId="clientId"></KeywordComponent>
</template>
<script>
import { paginationCurrent } from '../../untils/index'
import { PlusOutlined } from '@ant-design/icons-vue';
import { cloneDeep } from "lodash-es";
import { searchUserList, companyAdminOperateClient, selectArticleCategory, getCategoryList, setArticleCategory } from './js/index'
import { reactive, watch, ref, onMounted, toRefs, computed, nextTick } from 'vue'

import store from '@/store'
import dayjs from 'dayjs'
import { message } from 'ant-design-vue/lib/components'
import router from '@/router';
import KeywordComponent from '../mySubscribeComponent/component/keywordComponent.vue';
export default {
  name: 'manageUserPage',
  components: {
    PlusOutlined,KeywordComponent
  },
  setup() {
    const showModalKeywordVisible=ref(false)
    // watch(() => store.getters.company, (val) => {
    //   if (val && val != '') {
    //     var height = document.getElementById('container').offsetHeight
    //     scrollView.value = { height: (height-80 ) + 'px', overflow: 'auto' }
    //     pagination.companyId = store.getters.company.companyId
    //     toShowTable()
    //   }
    // })
    onMounted(() => {
      rangeTime.value = [dayjs(dayjs().subtract(1, 'day').format('YYYY-MM-DD') + " 00:00:00"), dayjs(dayjs().format('YYYY-MM-DD') + " 00:00:00")]
      var height = document.getElementById('container').offsetHeight
      scrollView.value = { height: (height-80) + 'px', overflow: 'auto' }
      if (store.getters.company) {
        pagination.companyId = store.getters.company.companyId
        toShowTable()
        getColumn()
      }
      
    })
    const toShowTable = async () => {
      editableData.value = []
      state.selectedRowKeys = []
      reloading.value = true
      var startTime = ''
      var endTime = ''
      if (rangeTime.value[0] != '') {
        startTime = dayjs(rangeTime.value[0]).format(dateFormat)
        endTime = dayjs(rangeTime.value[1]).format(dateFormat)
      }
      await store.dispatch("mobile").then(() => {
        var list = { company: pagination.companyId, mobile: mobile.value, current: pagination.current, size: pagination.pageSize }
        searchUserList(list).then((res) => {
          pagination.total = res.data.total


          nextTick(() => {
            for (var i in res.data.records) {
              if (res.data.records[i].mobile == store.getters.mobile) {
                res.data.records[i]['category'] = false
              }
              else res.data.records[i]['category'] = true
            }
            // for(var i =0;i<10;i++){
            //   res.data.records=res.data.records.concat(res.data.records)
            // }

            tableList.value = res.data.records
            modalEdit.editDataSource = res.data.records
            originalData.value = res.data.records == [] ? [] : JSON.parse(JSON.stringify(res.data.records))
            reloading.value = false
          })
        })



      })
    }
    const pagination = reactive({
      current: 1,
      pageSize: 100,
      companyId: '',
      total: 0,
      showTotal: function (total) {
        return "共：" + total + " 条";
      },
      pageSizeOptions: ['100', '200'],
    })
    const tableList = ref([])
    const scrollView = ref('')
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  
    const reloading = ref(false)
    const visible = ref(false)
    const rangeTime = ref(['', ''])
    const changeTime = () => {
      if (rangeTime.value == null) {
        message.warning('时间不能为空')
      }
      else {
        tableList.value = []
        pagination.current = 1
        toShowTable()
      }
    }
    const scrollY = ref(0)
    const toSearchUser = (val) => {
      pagination.current = 1
      rangeTime.value = [
        dayjs(dayjs().subtract(val, 'day').format("YYYY-MM-DD") + ' 00:00:00'),
        dayjs(dayjs().format("YYYY-MM-DD") + ' 00:00:00')
      ]
      tableList.value = []
      toShowTable()
    }
    const addShow = () => {
      for (var i in formState) {
        formState[i] = ''

      }
      if (newFormref.value && newFormref.value.clearValidate != undefined) {
        newFormref.value.clearValidate();
      }
      visible.value = true
    }
    const state = reactive({
      selectedRowKeys: []
    })
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys
    };
    const deleteList = ref([])
    const afterClose = () => {
      deleteList.value.length = []
      visible.value = false
    }


    const editableData = ref([]);
    const userformRef = ref([]);
    const editItem = (val) => {

      var len = modalEdit.editDataSource.length;
      let keys = Object.keys(rules);
      let resArr = [];
      for (var i = 0; i < len; i++) {
        resArr = [...resArr, ...keys.map((item) => item + "." + i)];
      }


      userformRef.value.validateFields(resArr).then(() => {
        editableData.value.push(
          cloneDeep(
            modalEdit.editDataSource.filter((item) => val === item.clientId)[0]
          )
        );
        console.log(editableData, 'editableData')
      }).catch(()=>{
        return 
      });
    };
    const cancel = (val) => {

      if (editableData.value.find((item) => item.clientId == val))
        editableData.value.splice(
          editableData.value.findIndex((item) => item.clientId == val),
          1
        );
      console.log(modalEdit, 'modalEdit.value', originalData.value)
      modalEdit.editDataSource[
        modalEdit.editDataSource.findIndex((item) => item.clientId == val)
      ] = originalData.value.find((item) => item.clientId == val);


    }
    const originalData = ref([])
    const categoryList = ref([])
    const toModalVisble = (val, flag) => {

      //originalData.value.find((item) => item.id == val)["operateType"] = -1;
      clientId.value = val
      
      deleteVisible.value = flag
      if(flag==true){
        modalVisible.value = true
      }
      else {
        console.log(modalEdit.editDataSource[
        modalEdit.editDataSource.findIndex((item) => item.clientId == val)
      ])
        userformRef.value.validateFields().then((val)=>{
          modalVisible.value = true
      }).catch(erro=>{
        console.log(erro,'erro')
        return 
      })
      }
    }
  
    const editArticleCategoryItem = (val, flag) => {
      clientId.value=val
      // if (categoryList.value && categoryList.value.length > 0)
      //   towatchCategoryList(val)

      // else {


      //   getCategoryList({ company: pagination.companyId }).then(res => {
      //     var list = []
      //     for (var i in res.data) {
      //       list.push({ label: res.data[i].name, value: res.data[i].id })
      //     }
      //     categoryList.value = list
      //     towatchCategoryList(val)

      //   })
      // }


      //originalData.value.find((item) => item.id == val)["operateType"] = -1;
      showModalKeywordVisible.value=true
   

    }
    const towatchCategoryList = (val) => {
      selectArticleCategory({ company: pagination.companyId, client: val }).then((resres) => {
        clientId.value = val
        modalVisibleCategory.value = true
        if (resres.data) { categoryListValue.value = resres.data }
        else {
          categoryListValue.value = categoryList.value.map(x => { return x.value })
        }
      })
    }

    const modalEdit = reactive({
      companyId: [],
      editDataSource: [],
    });
    const validateEmpty = (text) => {
      return (rule, value, callback) => {
        console.log(text, visible.value)
        var data = ""
        if (visible.value == true) {
          data = formState[text]
        }
        else {
          let index = rule.field.split(".")[1];
          data = modalEdit.editDataSource[index][text];
        }



        if (data == ""||data==null) {
          if(text=='subCompany') 
          callback("请选择");
          else 
          callback("请输入");
        } else if (text == "mobile") {
          if (data.length == 11) callback();
          else {
            callback("请输入正确的手机号码");
          }
        } 
        else {
          callback();
        }
      };
    };
    const rules = {
      clientName: [{ required: true, validator: validateEmpty("clientName"), trigger: "change" }],
      department: [{ required: true,  validator: validateEmpty("department"), trigger: "change" }],
      subCompany: [{ required: true,  validator: validateEmpty("subCompany"), trigger: "change" }],
      mobile: [{ validator: validateEmpty("mobile"), trigger: "change", required: true }],
    };
    const newList = ref([]);

    const formState = reactive({
      clientName: '',
      mobile: '',
      post: "",
      department:"",
      subCompany:null,

    });
    const mobile = ref("")
    const onSearch = () => {
      pagination.current = 1
      toShowTable()
    }
    const newFormref = ref(null)

    const handleTableChange = (page, pageSize) => {
      pagination.current =
        pageSize != pagination.pageSize ? 1 : page;
      pagination.pageSize = pageSize;
      pagination.current = page
      document.querySelector('.scrollViewPage').scrollTop = 0
      toShowTable()
    }
    const toAdd =  () => {


      newFormref.value
        .validateFields()
        .then(values => {

          toModal(values)


        }).catch(()=>{
          return
        })
    }
    const clientId = ref('')
    const deleteVisible = ref(false)
    const modalVisible = ref(false)
    const afterCloseModal = () => {
      modalVisible.value = modalVisibleCategory.value = false
    }
    const toModal = (val) => {
      if (confirmLoading.value == false) {
        confirmLoading.value = true
        var data = null
        var result = modalEdit.editDataSource.find(item => item.clientId == clientId.value)

        if (val) {
          data = val
          data["operateType"] = 1
          data["companyId"] = pagination.companyId
        }
        else {
          data = {

            "clientName": result.clientName,
            "post": result.post,
            "mobile": result.mobile,
            "companyId": pagination.companyId,
            "department":result.department,
            "subCompany":result.subCompany,


          }
          if (deleteVisible.value == true)
            data["operateType"] = -1
          else data["operateType"] = 0
          data['clientId'] = clientId.value
        }
        companyAdminOperateClient(data).then((res) => {

          if (res.msg == '处理成功') {
            message.success(val ? '新增成功' : (deleteVisible.value == true ? '删除成功！' : '修改成功！'))

            if (val == null) {
              pagination.current = paginationCurrent(pagination, 1)

            }

            else {
              pagination.current = 1
              mobile.value = ""
            }


            editableData.value = []
            modalVisible.value = visible.value = false
            toShowTable()

          }
          else {

            //message.warning(val ? '新增失败' : (deleteVisible.value == true ? '删除失败！' : '修改失败！'))
            message.warning(res.msg)
          }
          confirmLoading.value = false
        }).catch(() => {
          confirmLoading.value = false
        })
      }



    }
    const confirmLoading = ref(false)
    const modalVisibleCategory = ref(false)
    const categoryListValue = ref([])
    const toSetCategory = async () => {
      if (confirmLoading.value == false) {
        confirmLoading.value = true
        var list;
        if (categoryListValue.value.length == categoryList.value.length) list = null
        else list = categoryListValue.value
        await store.dispatch("clientId").then(() => {
          setArticleCategory({
            "categoryIds": list,
            "client": clientId.value,
            "company": pagination.companyId
          }).then(async (res) => {
            if (res.msg == '处理成功') {
              message.success(res.msg)
              modalVisibleCategory.value = false
            }
            else message.warning(res.msg)
            confirmLoading.value = false

            nextTick(() => {
              console.log(store.getters.clientId, 'store.getters.clientId')
              if (clientId.value == store.getters.clientId) {

                setTimeout(() => {
                  store.dispatch("reloadFlag", true)
                  store.dispatch("reloadINTFlag", true)
                  router.push({ name: 'homePage' })
                }, 20)

              }
            })


          }).catch(() => {
            confirmLoading.value = false
          })
        })
      }
    }
    const companyType = ref(store.getters.company.companyType)
    const toShowKeyword=(flag)=>{
              
showModalKeywordVisible.value=false
      }
      const columns=ref([])
      const   defaultcolumns=[
        {
          title: " 序号 ",
          // render: (text, record, index) => `${index + 1}`,  //每一页都从1开始
          customRender: (column) =>
            `${(pagination.current - 1) * pagination.pageSize + column.index + 1
            }`,
          width: "7%",
          align: 'center'
          //当前页数减1乘以每一页页数再加当前页序号+1
        },
        {
          dataIndex: "clientName",
          width:'10%',
          title: "姓名",
          align: 'center'
        },
       
        {
          dataIndex: "post",

          title: "职位",
          align: 'center',
          width:'15%',
        },
        {
          dataIndex: "mobile",
          key: "mobile",
          title: "手机号",
          align: 'center',
          width:'15%',
        },
        {
          dataIndex: "clientCreateTime",
          key: "clientCreateTime",
          title: "注册时间",
          align: 'center',
          width:'15%',
        },


        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          width: "10%"
        },
      ]
      const getColumn=()=>{
      var list =defaultcolumns
      if( pagination.companyId==793){
          list.splice(2,0,
          {
 dataIndex: "subCompany",
 title: "所属单位",
 align: 'center', width:'20%',
 }, { dataIndex: "department",
 title: "所在处室", align: 'center',
 width:'15%',
 },
)

      }
    columns.value =list
      }

    return {
    getColumn,
    columns,
      toShowKeyword,
      belongUnitOptions:[
    {
        "label": "公司总部",
        "value": "公司总部"
    },
    {
        "label": "运行管理中心",
        "value": "运行管理中心"
    },
    {
        "label": "杭州南管理中心",
        "value": "杭州南管理中心"
    },
    {
        "label": "衢州管理中心",
        "value": "衢州管理中心"
    },
    {
        "label": "金华管理中心",
        "value": "金华管理中心"
    },
    {
        "label": "台州管理中心",
        "value": "台州管理中心"
    },
    {
        "label": "丽水管理中心",
        "value": "丽水管理中心"
    },
    {
        "label": "温州管理中心",
        "value": "温州管理中心"
    }
],
      showModalKeywordVisible,
      companyType,
      toSetCategory,
      categoryListValue,
      categoryList,
      modalVisibleCategory,
      confirmLoading,
      toModal,
      afterCloseModal,
      toModalVisble,
      editArticleCategoryItem,
      modalVisible,
      deleteVisible,
      clientId,
      toAdd,
      handleTableChange,
      newFormref,
      onSearch,
      mobile,
      formState,
      newList,
      userformRef,
      rules,
      modalEdit,

      originalData,
      cancel,
      editItem,
      editableData,


      visible,
      afterClose,
      deleteList,
      onSelectChange,
      ...toRefs(state),
      addShow,
    
      toSearchUser,
      scrollY,
      changeTime,
      rangeTime,
      visible,
      reloading,
      scrollView,
      tableList,
      toShowTable,
      pagination,
    }
  },
  beforeRouteLeave(to, from, next) {
    //保存滚动条元素div的scrollTop值
    this.scrollY = document.querySelector('.scrollView').scrollTop
    next();
  },
  methods: {

  }
}
</script>
<style lang="less">
.searchmobile .ant-input-search-button{
  background: #00b2b9;
  border-color: #00b2b9;
}
.categorySelect {
  .ant-select-selection-item {
    background-color: #e6f7ff !important;
    color: #009da6 !important;
    border: 1px solid #e6f7ff !important;
  }
}
</style>
<style scoped lang="scss">
.tableStyle {
  margin-bottom: 0px !important;
}
</style>
<style>
.actionStyle {
  margin-right: 20px;
  ;
}

.tablestyle .ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
  padding: 8px 8px !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tablestyle {
  margin-top: 20px;
}

.scrollView {
  margin: 10px 0px;
}

.datelist {
  margin-left: 10px;
  display: inline-block;
}

.datelist a {
  margin-right: 10px;
}
</style>